import { Card, Form, Input } from 'antd';
import { EditLayout } from 'components/layout/layout/EditLayout';
import { EcommerceIconComponent } from 'assets/icons/ecommerce';
import { IEcommerceTag } from 'interfaces/ecommerce_tags';
import { PageHeader } from 'components/professor_area/PageHeader';
import { useForm } from '@refinedev/antd';

export const EcommerceTagEdit = () => {
  const { formProps, saveButtonProps } = useForm<IEcommerceTag>();

  return (
    <EditLayout saveButtonProps={saveButtonProps} title="Editar tag">
      <PageHeader
        title={formProps.initialValues?.name || 'Editar tag'}
        icon={EcommerceIconComponent}
      />

      <Card>
        <Form {...formProps} layout="vertical">
          <Form.Item
            label="Nome"
            name="name"
            rules={[
              {
                required: true,
                message: 'O nome é obrigatório'
              }
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Descrição"
            name="description"
            rules={[
              {
                required: true,
                message: 'A descrição é obrigatória'
              }
            ]}
          >
            <Input.TextArea rows={4} />
          </Form.Item>
        </Form>
      </Card>
    </EditLayout>
  );
};
